export const GET_SPECIALITIES_REQUEST = "GET_SPECIALITIES_REQUEST";
export const GET_SPECIALITIES_COMPLETED = "GET_SPECIALITIES_COMPLETED";
export const GET_SPECIALITIES_ERROR = "GET_SPECIALITIES_ERROR";

export const ADD_SPECIALITIES_REQUEST = "ADD_SPECIALITIES_REQUEST";
export const ADD_SPECIALITIES_COMPLETED = "ADD_SPECIALITIES_COMPLETED";
export const ADD_SPECIALITIES_ERROR = "ADD_SPECIALITIES_ERROR";

export const DELETE_SPECIALITIES_REQUEST = "DELETE_SPECIALITIES_REQUEST";
export const DELETE_SPECIALITIES_COMPLETED = "DELETE_SPECIALITIES_COMPLETED";
export const DELETE_SPECIALITIES_ERROR = "DELETE_SPECIALITIES_ERROR";

export const GET_SPECIALITYGROUP_REQUEST = "GET_SPECIALITYGROUP_REQUEST";
export const GET_SPECIALITYGROUP_COMPLETED = "GET_SPECIALITYGROUP_COMPLETED";
export const GET_SPECIALITYGROUP_ERROR = "GET_SPECIALITYGROUP_ERROR";